import { render } from "./StudentTotalList.vue?vue&type=template&id=f48c5ac2&scoped=true"
import script from "./StudentTotalList.vue?vue&type=script&lang=js"
export * from "./StudentTotalList.vue?vue&type=script&lang=js"

import "./StudentTotalList.vue?vue&type=style&index=0&id=f48c5ac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f48c5ac2"]])

export default __exports__